import i18n from '@/i18n';
import {
	CompanyNeedPriority,
	type CompanyNeedPriorityInfo,
} from '@/modules/companyNeed/types/priority';

import { DropdownItemColors } from '@/dsComponents/Dropdown/types';

export const CompanyNeedPriorityOptions = [
	{
		label: i18n.global.t('global.priorities.low'),
		value: CompanyNeedPriority.LOW,
		icon: 'priority-0',
		color: DropdownItemColors.blue,
		order: 2,
	},
	{
		label: i18n.global.t('global.priorities.medium'),
		value: CompanyNeedPriority.MEDIUM,
		icon: 'priority-1',
		color: DropdownItemColors.grey,
		order: 1,
	},
	{
		label: i18n.global.t('global.priorities.high'),
		value: CompanyNeedPriority.HIGH,
		icon: 'alert-square-fill',
		color: DropdownItemColors.red,
		order: 0,
	},
];

export const getSortedCompanyNeedPriorityOptions = () => {
	return CompanyNeedPriorityOptions.sort((a, b) => a.order - b.order);
};

export const getCompanyNeedPriorityInfos = (
	priority: CompanyNeedPriority
): CompanyNeedPriorityInfo => {
	const option = CompanyNeedPriorityOptions.find(
		(option) => option.value === priority
	);
	if (!option) {
		return {
			label: i18n.global.t('global.notDefined'),
			value: priority,
		};
	}
	return option;
};
